import axios from 'axios';
axios.defaults.headers.common['X-Source-App'] = 'OrderPortal';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const basicAuth = JSON.parse(localStorage.getItem('userId'));

let config = {
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000 // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

// Log warning if API URL is not configured
if (!process.env.VUE_APP_API_URL) {
  console.warn('Warning: VUE_APP_API_URL is not configured! Add it to your .env file.');
}

if (basicAuth) {
  axios.defaults.headers.common['Authorization'] = basicAuth;
}

const apiInst = axios.create(config);

export default apiInst;
